import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import App from "./App";
import { SocketProvider } from "./context/socketProvider";
import useWeglotInitializer from "./i18n/hooks/useWeglotInitializer";
import useRegionDetector from "./i18n/hooks/useRegionDetector";
import RegionBanner from "./components/regionSelector/RegionBanner";
import LanguageChangeDialog from "./components/languageChangeDialog/LanguageChangeDialog";
import "./index.css";
import makeStore from "./redux/store";

const store = makeStore();

function PageToTop() {
    useWeglotInitializer();
    useRegionDetector();
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

// ReactDOM.render(
//   <CookiesProvider>
//     <React.Fragment>
//       <Router>
//         <Provider store={store}>
//           <PageToTop />
//           <App />
//         </Provider>
//       </Router>
//     </React.Fragment>
//   </CookiesProvider>,
//   document.getElementById('root')
// );

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

root.render(
    <CookiesProvider>
        <React.Fragment>
            <Router>
                <Provider store={store}>
                    <SocketProvider>
                        <PageToTop />
                        <RegionBanner />
                        <LanguageChangeDialog />
                        <App />
                    </SocketProvider>
                </Provider>
            </Router>
        </React.Fragment>
    </CookiesProvider>,
);
